/**
 * In-memory log ring buffer — son 50 kayıt. Diagnostic overlay buradan okur.
 *
 * console.error/warn/info çağrıları otomatik buffer'a yazılır (wrapper).
 * Disk'e/sunucuya gitmez — disposable; cihaz yeniden başlayınca sıfırlanır.
 *
 * Memory: decision_pwa_resilience.md §11
 */
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface LogEntry {
    ts: number;
    level: LogLevel;
    message: string;
}

const MAX_ENTRIES = 50;
const buffer: LogEntry[] = [];

export function log(level: LogLevel, message: string): void {
    buffer.push({ ts: Date.now(), level, message });
    if (buffer.length > MAX_ENTRIES) buffer.shift();
}

export function snapshot(): LogEntry[] {
    return [...buffer];
}

export function clearLogs(): void {
    buffer.length = 0;
}

/** console.error/warn/info'yu sarmalar — uygulama log'larını buffer'a yakalar. */
export function installConsoleCapture(): void {
    const wrap = (level: LogLevel, orig: (...a: unknown[]) => void) => {
        return (...args: unknown[]): void => {
            try {
                log(level, args.map((a) => String(a)).join(' '));
            } catch {
                // log capture asla uygulamayı bozmasın
            }
            orig(...args);
        };
    };

    // Not: console metotlari bilerek sarmalaniyor (tani ekrani icin tampon).
    console.error = wrap('error', console.error.bind(console));
    console.warn = wrap('warn', console.warn.bind(console));
    console.info = wrap('info', console.info.bind(console));
}
